import { getElements, ifSelectorExist } from "./utils";

export const showMore = () => {
  const showMoreButtons = getElements(
    ".jpcarroll-testimonials-block__item_show_more"
  );

  if (ifSelectorExist) {
    showMoreButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const reviewBlock = this.closest(".jpcarroll-testimonials-block__item");
        const shortReview = reviewBlock.querySelector(".short-review");
        const fullReview = reviewBlock.querySelector(".full-review");

        if (shortReview.style.display === "none") {
          shortReview.style.display = "inline";
          fullReview.style.display = "none";
          this.textContent = "Show More";
        } else {
          shortReview.style.display = "none";
          fullReview.style.display = "inline";
          this.textContent = "Show Less";
        }
      });
    });
  }
};
